module.exports = __webpack_public_path__ + "static/media/img_qudao12@2x.f886d0ee.png";